<template>
  <div class="container">
    <div class="content-wrapper" :class="{iframe: isViewiFrame}">
      <h2>Potwierdź formularz</h2>
      <topup-summary />
    </div>
  </div>
</template>

<script>
import TopupSummary from '@/pge/components/Topup/Summary'
import { APP_VIEW } from '@/pge/const/config.const'
import { mapState } from 'vuex'
export default {
  name: 'TopupSummaryView',
  components: { TopupSummary },
  computed: {
    ...mapState({
      isViewiFrame: state => state.pge.view === APP_VIEW.iframe
    })
  }
}
</script>
